module.exports = __webpack_public_path__ + "static/performance8-8230c74538a86aaee94517c38acbe3e1.jpg";